import { render, staticRenderFns } from "./CustomerDetailsTab.vue?vue&type=template&id=b0caecac&scoped=true&"
import script from "./CustomerDetailsTab.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsTab.vue?vue&type=style&index=0&id=b0caecac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0caecac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
